import React from "react"
import { ProductFinanceDisclaimer } from "../../templates/product"
import style from "./finance.mod.scss"
import { GatsbyImage } from "gatsby-plugin-image"
import FinanceIcon from "@svgs/finance.svg"

const Finance = ({
  finance,
  footer = false,
  card,
  newV = false,
  isSauna = false
}) => {
  // Early return if finance is not available
  if (!finance || !Array.isArray(finance) || finance.length === 0) {
    return null
  }

  const classes = [style.finance]

  footer && classes.push(style["finance--footer"])
  if (isSauna && newV) {
    classes.push(style["finance--new--sauna"])
  } else if (newV) {
    classes.push(style["finance--new"])
  }

  if (card) {
    return (
      <div className={style.finance__card}>
        <FinanceIcon aria-hidden />
        <p>{"Finance options available."}</p>
        <span>More info</span>
      </div>
    )
  }

  return (
    <div className={classes.join(" ")}>
      <h4>Available finance options</h4>
      {finance.length > 1 ? (
        <>
          <div className={style.finance__title}>
            {finance.map(
              (item, index) =>
                item && (
                  <GatsbyImage
                    key={index}
                    image={
                      item.wideIcon
                        ? item.logoWide?.gatsbyImageData
                        : item.logo?.gatsbyImageData
                    }
                  />
                )
            )}
          </div>
          <div className={style.finance__disclaimer}>
            <ProductFinanceDisclaimer
              displayText={"Terms and conditions"}
              linkPath={"/learn/finance/"}
              footer={footer}
              //   linkPath={"/contact-us/finance-enquiry/"}
            />
          </div>
        </>
      ) : (
        <>
          {finance[0] && (
            <>
              <div className={style.finance__title}>
                <GatsbyImage
                  image={
                    finance[0].wideIcon
                      ? finance[0].logoWide?.gatsbyImageData
                      : finance[0].logo?.gatsbyImageData
                  }
                />
              </div>
              <div className={style.finance__disclaimer}>
                <ProductFinanceDisclaimer
                  //   displayText={finance[0].name}
                  displayText={"Terms and conditions"}
                  //   linkPath={finance[0].enquiryFormPage.path}
                  linkPath={"/learn/finance/"}
                  footer={footer}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default Finance
